import CountryFlag from 'vue-country-flag-next'
import countries from 'i18n-iso-countries'
import _ from 'lodash'

import * as enLocale from 'i18n-iso-countries/langs/en.json'
import * as frLocale from 'i18n-iso-countries/langs/fr.json'
import * as nlLocale from 'i18n-iso-countries/langs/nl.json'
import * as deLocale from 'i18n-iso-countries/langs/de.json'
import * as esLocale from 'i18n-iso-countries/langs/es.json'
import * as arLocale from 'i18n-iso-countries/langs/ar.json'
import * as jaLocale from 'i18n-iso-countries/langs/ja.json'
import * as ruLocale from 'i18n-iso-countries/langs/ru.json'

countries.registerLocale(enLocale)
countries.registerLocale(frLocale)
countries.registerLocale(nlLocale)
countries.registerLocale(deLocale)
countries.registerLocale(esLocale)
countries.registerLocale(arLocale)
countries.registerLocale(jaLocale)
countries.registerLocale(ruLocale)

// @qa-tests: UpgradePlan
export default {
  name: 'selectCountry',
  inject: [
    '$dataStore'
  ],
  components: {
    CountryFlag
  },
  props: {
    countryCode: {
      type: String,
      default: ''
    }
  },
  watch: {
    countryCode (code) {
      if (this.code) {
        this.setModelData({ countryCode: code })
      }
      this.refreshForm()
    }
  },
  computed: {
    countryName () {
      return _.find(this.countries, (country) => country.code === this.model.countryCode)?.name ?? this.$t('planUpgrade.selectCountry')
    },
    hasSelectedCountry () {
      return !_.isEmpty(this.model.countryCode)
    }
  },
  mixins: [],
  data () {
    return {
      model: {
        countryCode: ''
      },
      countries: [],
      showAutocomplete: false
    }
  },
  methods: {
    setModelData (data) {
      this.model.countryCode = data?.countryCode ?? ''
    },
    setCountries () {
      const selectedLanguage = this.$dataStore.getLanguage()?.code ?? 'en'

      // All names by their ISO 3166-1 Alpha-2
      const countriesMap = _.map(
        countries.getNames(selectedLanguage, { select: 'official' }),
        (name, code) => ({ name, code })
      )

      const collator = new Intl.Collator(selectedLanguage)
      this.countries = countriesMap.sort((c1, c2) => collator.compare(c1.name, c2.name))
    },
    setAutoCompletePosition () {
      const parentEl = this.$refs.selectCountry
      const autoCompleteWrapperEl = this.$refs.countryAutoCompleteWrapper
      const topValue = parentEl?.clientHeight ?? 34
      const widthValue = parentEl?.clientWidth ?? 190

      autoCompleteWrapperEl.style.top = `${topValue}px`
      autoCompleteWrapperEl.style.width = `${widthValue}px`
    },
    handleArrowClick () {
      if (this.showAutocomplete) {
        this.showAutocomplete = false
      } else {
        this.showAutocomplete = true
      }

      this.setAutoCompletePosition()
      this.$nextTick(_ => {
        this.$refs.countryAutoCompleteSelectbox.focus()
      })
    },
    handleDropdownChange () {
      this.showAutocomplete = false
      this.$emit('change', { countryCode: this.model.countryCode, countryName: this.countryName })
    },
    refreshForm () {
      this.model.countryCode = this.countryCode
    }
  },
  mounted () {
    this.setModelData({ countryCode: this.countryCode })
    this.setCountries()
  }
}
